import React from "react";
import PropTypes from "prop-types";
import { Avatar, Card, CardContent, Stack, Typography } from "@mui/material";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

const getAvatarText = (name) => {
  const fullName = name.split(" ");
  const reverseName = name.split(" ").reverse();

  return `${fullName[0][0]}${reverseName[0][0]}`;
};

const CommentBox = ({ comment, name, createdAt, role }) => {
  return (
    <Stack direction="row" spacing={1}>
      <Avatar sx={{ width: 28, height: 28, fontSize: 16 }} className="p-1">
        {getAvatarText(name)}
      </Avatar>
      <Card variant="outlined" className="p-0 mb-2 w-100">
        <CardContent
          sx={{ maxHeight: "260px", overflowX: "scroll", paddingTop: "4px" }}
        >
          <div className="d-flex justify-content-between">
            <Typography color="GrayText" variant="body2" gutterBottom>
              {name} {role && `(${role})`}
            </Typography>
            <Typography variant="caption" color="GrayText" gutterBottom>
              Commented on{" "}
              {convertUTCDateToLocalDate(createdAt).format(
                "DD-MM-YYYY HH:mm:ss A"
              )}
            </Typography>
          </div>
          <Typography
            className="mt-2"
            variant="body1"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {comment}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
};

CommentBox.propTypes = {
  comment: PropTypes.string,
  name: PropTypes.string,
  createdAt: PropTypes.string,
  role: PropTypes.string,
};

export default CommentBox;
